import type { ReactNode } from 'react';

import s from './EmptyState.module.css';

interface Props {
  /** One line saying what is missing. */
  title: string;
  /**
   * What to do about it. Empty states earn their space by telling someone the
   * next action, not by announcing an absence they can already see.
   */
  hint?: string;
  action?: ReactNode;
  /** `plain` drops the dashed frame, for empties nested inside a card. */
  variant?: 'framed' | 'plain';
}

export function EmptyState({ title, hint, action, variant = 'framed' }: Props): JSX.Element {
  return (
    <div className={variant === 'framed' ? s.framed : s.plain}>
      <p className={s.title}>{title}</p>
      {hint !== undefined ? <p className={s.hint}>{hint}</p> : null}
      {action !== undefined ? <div className={s.action}>{action}</div> : null}
    </div>
  );
}
